<template>
  <el-card v-show="visible" ref="card" class="base-tool" :style="point">
    <div slot="header" class="base-tool__header">
      <span class="base-tool__title">{{ title }}</span>

      <span class="base-tool__close" @click="close">
        <i class="el-icon-close"></i>
      </span>
    </div>
    <slot></slot>
  </el-card>
</template>

<script>
import { nextIndex } from './utils'

export default {
  props: {
    title: {
      type: String,
    },

    width: {
      type: Number,
      default: 0,
    },

    visible: {
      type: Boolean,
    },
  },

  data() {
    return {
      current: {
        x: 0,
        y: 0,
        zIndex: nextIndex(),
      },
    }
  },

  computed: {
    point() {
      const { x, y, zIndex } = this.current

      return {
        left: x + 'px',
        top: y + 'px',
        'z-index': zIndex,
        transition: 'none',
        width: this.width + 'px',
      }
    },
  },

  watch: {
    visible(k) {
      if (k) {
        const el = this.$el
        if (el) {
          document.body.append(el)
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.$on('destroyed', this.init()))

    this.$nextTick(() => {
      const el = this.$el
      if (el) {
        document.body.append(el)
      }
    })
  },

  beforeDestroy() {
    this.$emit('destroyed')

    const el = this.$el

    if (el && el.parentNode) {
      el.parentNode.removeChild(el)
    }
  },

  methods: {
    close() {
      this.$emit('update:visible', false)
    },

    init() {
      const card = this.$refs.card

      if (card && card.$el) {
        const head = card.$el.querySelector('.el-card__header')
        this.current.x = Math.floor((window.innerWidth - this.width) / 2)
        this.current.y = Math.max(10, Math.floor(window.innerHeight / 2) - 200)

        if (head) {
          const point = {
            x: 0,
            y: 0,
            zIndex: 0,
            active: false,
            x1: 0,
            y1: 0,
          }

          let width, height

          const mousemove = event => {
            if (point.active) {
              let x = point.x1 + (event.pageX - point.x)
              let y = point.y1 + (event.pageY - point.y)

              if (x <= 10) {
                x = 10
              }

              if (x >= width - this.width - 10) {
                x = width - this.width - 10
              }

              if (y <= 10) {
                y = 10
              }

              if (y >= height - 100) {
                y = height - 100
              }

              this.current.x = x
              this.current.y = y
            }
          }

          const mouseup = () => {
            point.active = false
            document.removeEventListener('mousemove', mousemove)
            document.removeEventListener('mouseup', mouseup)
          }

          const mousedown = event => {
            point.active = true
            point.x = event.pageX
            point.y = event.pageY
            this.current.zIndex = nextIndex()

            point.x1 = this.current.x
            point.y1 = this.current.y

            width = window.innerWidth
            height = window.innerHeight
            document.addEventListener('mousemove', mousemove)
            document.addEventListener('mouseup', mouseup)
          }

          head.addEventListener('mousedown', mousedown)

          return () => head.removeEventListener('mousedown', mousedown)
        }
      }

      return () => null
    },
  },
}
</script>

<style lang="scss" scoped>
.base-tool {
  position: absolute;

  .base-tool__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
  }

  .base-tool__title {
    font-size: 13px;
    font-weight: bold;
    flex-grow: 1;
  }

  .base-tool__close {
    font-size: 12px;
    padding: 3px 0;
    cursor: pointer;

    &:hover {
      color: #555;
    }
  }
}
</style>
>
